export const stringsToFetch = [
	'PUBLIC_APP_URL_info',
	'PUBLIC_APP_URL_booking',
	'PUBLIC_APP_URL_checkout',
	'PUBLIC_APP_URL_awaiting-payment',
	'Prices_set_in_CURR_prices_may_vary_info',
	'Currency',
	'Passengers',
	'Group',
	'GROUP',
	'group',
	'Private',
	'PRIVATE',
	'private',
	'PER_PERSON_ABBREV',
	'Add_to_cart',
	'Add',
	'Remove',
	'Added_as_private_activity',
	'Added_as_group_activity',
	'Added',
	'Close',
	'total',
	'people',
	'person',
	'Change',
	'Select_passenger_amount',
	'AGE_GROUP_TITLE_infant',
	'AGE_GROUP_TITLE_child',
	'AGE_GROUP_TITLE_youth',
	'AGE_GROUP_TITLE_adult',
	'AGE_GROUP_TITLE_senior',
	'years',
	'Activity',
	'Price_pp',
	'Total',
	'Total_pp',
	'Cart_is_empty',
	'Cart',
	'Go_to_checkout',
	'Please_select_a_date',
	'Reload',
	'Start_time',
	'Duration',
	'days',
	'day',
	'hours',
	'hour',
	'minutes',
	'minute',
	'Name_unset',
	'More_info',
	'day_ABBREV',
	'hour_ABBREV',
	'minute_ABBREV',
	'ACTIVITY_CATEGORY_Other',
	'Price_unset',
	'LOW_AVAILABILITY_DIALOG_INSUFFICIENT_1',
	'LOW_AVAILABILITY_DIALOG_SOLD_OUT_1',
	'LOW_AVAILABILITY_DIALOG_REQUEST_SPACE_INFO',
	'Send',
	'Country',
	'Error',
	'Message_sent',
	'SPACE_REQUEST_WE_HAVE_RECEIVED_REQUEST_INFO',
	'Low_availability',
	'Sold_out',
	'Activities_removed_from_cart',
	'ACTIVITIES_REMOVED_FROM_CART_INSUF_AVAIL_INFO',
	'Recommended_activities',
	'RECOMMENDED_ACTIVITIES_CTA_INFO',
	'Continue_without_recommended_activities',
	'Contact',
	'Name',
	'Email',
	'Message',
	'Phone',
	'Please_fill_out_this_field',
	'Email_invalid',
	'Passenger_amount',
	'Arrival_and_departure',
	'Arrival_date',
	'Departure_date',
	'Arrival_time',
	'Departure_time',
	'Arrival_flight_trans_no',
	'Departure_flight_trans_no',
	'Arr_transp_no_ABBREV',
	'Dep_transp_no_ABBREV',
	'User_already_exists',
	'AGE_GROUP_TITLE_adult',
	'AGE_GROUP_TITLE_child',
	'AGE_GROUP_TITLE_infant',
	'AGE_GROUP_TITLE_senior',
	'AGE_GROUP_TITLE_youth',
	'FIRST_PAX_FIELD_LOCKED_HELP',
	'ERR_Unexpected_error',
	'TOURS_OUTSIDE_DATE_RANGE_CONTACT_US_TO_HELP_INFO',
	'Add_language',
	'Add_language_to_all',
	'Remove_LANGUAGE',
	'ERRORS_IN_FORM_PLZ_TRY_AGAIN',
	'FORM_FIELD_contactName',
	'FORM_FIELD_contactEmail',
	'FORM_FIELD_contactCountry',
	'FORM_FIELD_contactPhones',
	'FORM_FIELD_lodging',
	'FORM_FIELD_pickupLocationId',
	'FORM_FIELD_arrivalDate',
	'FORM_FIELD_departureDate',
	'FORM_FIELD_passengers',
	'Location',
	'Lodging',
	'Pickup_location',
	'Continue_typing_for_more_options',
	'LODGING_REQUIRED_INFO_PART_1',
	'LODGING_REQUIRED_INFO_PART_contact_us',
	'LODGING_REQUIRED_INFO_PART_2',
	'Yes',
	'No',
	'Specify_details',
	'Agent',
	'Discount',
	'PRICES_UNSET_CONTACT_US_TO_HELP_INFO',
	'Send_inquiry',
	'SEND_INQUIRY_CHK_AVAIL_RETURN_ASAP',
	'Book_and_pay',
	'SORRY_FOLLOWING_ACTIVITIES_JUST_SOLD_OUT',
	'Please_go_back_and_try_again',
	'Back',
	'Select_payment_method',
	'No_payment_methods_available',
	'fee',
	'GATEWAY_EXTRA_TRANSACTION_FEE_INFO',
	'Per_person',
	'Total',
	'Pay_now',
	'PAY_IN_DIFF_CURR_Will_be_charged_as',
	'Read_terms',
	'I_have_read_and_accept_the_terms',
	'Terms',
	'BOOKING_STATUS_TITLE_C',
	'BOOKING_STATUS_TITLE_N',
	'BOOKING_STATUS_TITLE_U',
	'BOOKING_STATUS_TITLE_D',
	'BOOKING_STATUS_TITLE_P',
	'Status',
	'ID',
	'Booking',
	'Created_on_TIME',
	'Created_by_PERSON',
	'Contact',
	'Amount_of_passengers',
	'Client',
	'UNSET',
	'Totals',
	'Total_paid',
	'Left_to_pay',
	'ACTIVITY_TYPE_TITLE_custom',
	'ACTIVITY_TYPE_TITLE_group',
	'ACTIVITY_TYPE_TITLE_lodgingToSell',
	'ACTIVITY_TYPE_TITLE_private',
	'ACTIVITY_TYPE_TITLE_shoreExcursion',
	'Date_unset',
	'Time_unset',
	'DEPOSIT_How_much_pay_now_Q',
	'PUBLIC_APP_URL_info',
	'PUBLIC_APP_URL_checkout',
	'PUBLIC_APP_URL_booking',
	'PUBLIC_APP_URL_pay',
	'Thank_you_EXCL',
	'Payment_recieved_booking_confirmed',
	'Payment_received',
	'If_we_can_help_out_dont_hesitate_to',
	'IF_CAN_HELP_PLEASE_DONT_HESITATE_TO_contact_us',
	'ERROR_TRY_AGAIN_OR_CONTACT_ERROR_INFO_RETRIEVED_PART_1',
	'ERROR_TRY_AGAIN_OR_CONTACT_ERROR_INFO_RETRIEVED_PART_2_try_again',
	'ERROR_TRY_AGAIN_OR_CONTACT_ERROR_INFO_RETRIEVED_PART_3',
	'Activities',
	'Checkout',
	'Booking',
	'Confirming_payment',
	'Awaiting_payment',
	'Contact_person_is_on_this_trip',
	'Waiting_for_payment_confirmation',
	'WAITING_FOR_PAYMENT_CONFIRMATION_INFO',
	'Translation_incomplete',
	'Invalid_page',
	'No_availability',
	'NO_AVAILABILITY_ANYMORE_INFO',
	'No_available_dates_in_this_month',
	'Loading_month',
	'Booked_lodging',
	'Room',
	'Inquiry_has_been_sent_successfully_EXCL',
	'SEND_INQUIRY_CHK_AVAIL_RETURN_ASAP',
	'Your_booking_has_been_successfully_created_EXCL',
	'Added_to_cart',
	'ADDED_TO_CART_INFO',
	'TAB_included',
	'TAB_notIncluded',
	'TAB_whatToBring',
	'TOUR_DEP_NO_MORE_AVAIL'
];